import React, { useState } from "react";
import { CachingService } from "../../services/CachingService";
import { FieldWrapper } from "../campaigns/FieldWrapper";
import { CustomSelect } from "../common/CustomSelect";
import { BreadCrumb } from "../common/BreadCrumb";
import { useGroupKeys } from "../../hooks/useGroupKeys";
import { toast } from "react-toastify";
import {
  NavigationItem,
  NavigationSettings,
} from "../common/NavigationSettings";
import { isEmpty, startCase } from "lodash";

const normalizeRedisKey = (key) => {
  if (key === "GPay") return "GPay";
  if (key === "PWSMHomePage") return "Homepage, Banners, Carousels, Top Movies";
  return startCase(key);
};

export const CacheClearing = () => {
  const { results: groupKeys } = useGroupKeys();
  const [groupKey, setGroupKey] = useState("");
  const [loading, setLoading] = useState(false);

  const invalidate = (key) => {
    setLoading(true);
    new CachingService()
      .invalidate(key)
      .then(() => {
        toast.success(`${key} group has been invalidated.`);
        setGroupKey("");
      })
      .finally(() => setLoading(false));
  };

  const getNavigationSettings = () => {
    return new NavigationSettings({
      activeModule: new NavigationItem({
        identifier: "cache_clear",
        name: "Cache Invalidations",
      }),
    });
  };

  return (
    <div className="main-content">
      <BreadCrumb navigationSettings={getNavigationSettings()} />
      <div className="section__content section__content--p30">
        <div className="container-fluid">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                <div className="row form-group">
                  <div className="col-md-8">
                    <FieldWrapper
                      label="Group key"
                      input={
                        <CustomSelect
                          data={groupKeys.map((x) => ({
                            name: normalizeRedisKey(x),
                            value: x,
                          }))}
                          label="name"
                          value="value"
                          onChange={(e) => setGroupKey(e.value)}
                          selectedValue={groupKey}
                        />
                      }
                      action={
                        <button
                          className="btn btn-primary"
                          onClick={() => invalidate(groupKey)}
                          disabled={loading || isEmpty(groupKey)}
                        >
                          Invalidate
                        </button>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
